import React from 'react';
import {
  Box,
  Text,
  Flex,
  Button,
  Grid,
  VStack,
  useClipboard,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';

const BackupCodesDisplay = ({ codes, onConfirm }) => {
  const codesText = codes.join('\n');
  const { hasCopied, onCopy } = useClipboard(codesText);

  const handleDownload = () => {
    const element = document.createElement('a');
    const file = new Blob([codesText], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = `awake-backup-codes-${new Date().getTime()}.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    toast.success('Backup codes downloaded');
  };

  const handleCopy = () => {
    onCopy();
    toast.success('Backup codes copied to clipboard');
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <VStack spacing="2rem" align="stretch">
      <Box
        bg="#FFF9E6"
        border="2px solid #FFC107"
        borderRadius="8px"
        p="1.5rem"
      >
        <Text fontSize="16px" fontFamily="bold" color="#F57C00" mb="0.5rem">
          ⚠️ Important: Save These Backup Codes
        </Text>
        <Text fontSize="14px" color="#666" lineHeight="1.6">
          Save these backup codes in a secure location. Each code can only be
          used once to access your account if you lose your authenticator
          device. These codes will not be shown again.
        </Text>
      </Box>

      <Grid templateColumns="repeat(2, 1fr)" gap="1rem">
        {codes.map((code, index) => (
          <Box
            key={index}
            bg="#F5F5F5"
            p="1rem"
            borderRadius="6px"
            border="1px solid #E0E0E0"
          >
            <Text
              fontFamily="monospace"
              fontSize="16px"
              fontWeight="600"
              color="#444"
              letterSpacing="0.1rem"
            >
              {code}
            </Text>
          </Box>
        ))}
      </Grid>

      <Flex gap="1rem">
        <Button
          flex="1"
          bg="white"
          color="#1A73E8"
          border="1px solid #1A73E8"
          fontSize="14px"
          fontFamily="medium"
          h="45px"
          onClick={handleCopy}
          _hover={{ bg: '#EBF4FF' }}
        >
          {hasCopied ? 'Copied!' : 'Copy All Codes'}
        </Button>
        <Button
          flex="1"
          bg="white"
          color="#1A73E8"
          border="1px solid #1A73E8"
          fontSize="14px"
          fontFamily="medium"
          h="45px"
          onClick={handleDownload}
          _hover={{ bg: '#EBF4FF' }}
        >
          Download Codes
        </Button>
      </Flex>

      <Button
        bg="#1A73E8"
        color="white"
        fontSize="14px"
        fontFamily="medium"
        h="45px"
        onClick={handleConfirm}
        _hover={{ bg: '#1558D6' }}
      >
        I have saved my backup codes
      </Button>
    </VStack>
  );
};

export { BackupCodesDisplay };
